import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Router, RouterLink } from '@angular/router';

@Component({
    selector: 'app-default-not-found',
    templateUrl: './default-not-found.component.html',
    styleUrls: ['./default-not-found.component.scss'],
    standalone: true,
    imports: [MatButtonModule, RouterLink]
})
export default class DefaultNotFoundComponent {
  constructor(private router: Router) {
    setTimeout(() => {
      void this.router.navigateByUrl('/');
    }, 1500)
  }
}
